class FindCarForm {
  constructor(formElement) {
    this.form = formElement;
    this.config = window.findCarFormConfig || {};
    this.submitButton = this.form.querySelector('.find-car-form__submit');
    this.submitText = this.form.querySelector('.find-car-form__submit-text');
    this.submitLoader = this.form.querySelector('.find-car-form__submit-loader');
    this.successBox = this.form.closest('.find-car-form-container').querySelector('.find-car-form__success');

    this.formData = {};
    this.submissionStartTime = null;
    this.isSubmitting = false;

    this.init();
  }

  init() {
    // Check if URL has ?form=success parameter
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('form') === 'success') {
      this.showSuccess();
      return; // Don't initialize form if showing success
    }

    // Podmíněné zobrazení pole "Název firmy"
    this.setupConditionalFields();

    // Prefill z car-finder wizardu (session + URL)
    this.applyCarFinderPrefill(urlParams);

    // Form submission
    this.form.addEventListener('submit', this.handleSubmit.bind(this));

    // Real-time validace
    this.form.querySelectorAll('input:not(.find-car-form__honeypot), textarea').forEach((field) => {
      field.addEventListener('blur', () => this.validateField(field));
      field.addEventListener('input', () => {
        // Odstranit chybu při psaní, pokud pole je validní
        if (field.classList.contains('invalid')) {
          this.validateField(field);
        }
      });
    });

    // Speciální validace pro roční nájezd - povolit jen čísla
    const annualMileageField = this.form.querySelector('#annualMileage');
    if (annualMileageField) {
      // Při psaní povolit jen čísla - odstranit všechny ne-numerické znaky
      annualMileageField.addEventListener('input', (e) => {
        const cursorPos = e.target.selectionStart;
        let value = e.target.value;
        // Odstranit "km" pokud tam je při psaní
        value = value.replace(/\s*km\s*$/i, '');
        // Odstranit vše kromě číslic
        value = value.replace(/[^\d]/g, '');
        e.target.value = value;
        // Obnovit pozici kurzoru (přibližně)
        const newCursorPos = Math.min(cursorPos, value.length);
        e.target.setSelectionRange(newCursorPos, newCursorPos);
      });

      // Při focusu odstranit " km" pokud tam je, aby uživatel mohl snadno upravit
      annualMileageField.addEventListener('focus', (e) => {
        let value = e.target.value.replace(/\s*km\s*$/i, '');
        e.target.value = value;
      });

      // Při bluru přidat " km" pokud tam není a je tam číslo
      annualMileageField.addEventListener('blur', (e) => {
        let value = e.target.value.replace(/\s*km\s*$/i, '');
        if (value && /^\d+$/.test(value)) {
          e.target.value = value + ' km';
        }
      });
    }

    // Track form start
    if (this.config.enableAnalytics) {
      this.trackEvent('form_start');
    }

    // Zaznamenat čas načtení pro anti-spam
    this.submissionStartTime = Date.now();
  }

  applyCarFinderPrefill(urlParams) {
    let payload = null;
    try {
      const raw = window.sessionStorage.getItem('driveto_car_finder_prefill');
      if (raw) payload = JSON.parse(raw);
    } catch {
      payload = null;
    }

    const mileageFromUrl = urlParams.get('annualMileage');
    const noteField = this.form.querySelector('#note');
    const mileageField = this.form.querySelector('#annualMileage');

    if (mileageField) {
      const km = (payload && payload.annualMileage) || mileageFromUrl || '';
      if (km && /^\d+$/.test(String(km))) {
        mileageField.value = `${km} km`;
      }
    }

    if (noteField && payload && payload.note && !noteField.value.trim()) {
      noteField.value = payload.note;
    }

    // Preferovaný model/značku necháváme prázdné — wizard je neřeší.
    // Do note jdou věty pro věci, co do polí nesedí.
    if (payload && payload.source === 'car-finder') {
      const heading = document.querySelector('.find-car-form__heading');
      const description = document.querySelector('.find-car-form__description');
      if (heading && !heading.dataset.carFinderTouched) {
        heading.dataset.carFinderTouched = '1';
        // necháme CMS text; poznámka už nese kontext
      }
      if (description && payload.summary && payload.summary.length) {
        description.dataset.carFinderTouched = '1';
      }

      try {
        // one-shot — ať při reloadu zůstane, ale po odeslání smažeme ve success
        window.sessionStorage.setItem('driveto_car_finder_prefill_applied', '1');
      } catch {
        /* ignore */
      }
    }
  }

  setupConditionalFields() {
    // Setup tab buttons (mimo formulář)
    const tabButtons = document.querySelectorAll('.tab-button');
    const hiddenInput = this.form.querySelector('input[name="customerType"]');
    const companyField = this.form.querySelector('[data-show-when="customerType:firm"]');
    const companyInput = companyField?.querySelector('input');

    // Funkce pro aktualizaci hodnoty podle aktivního tlačítka
    const updateCustomerType = (button) => {
      const customerType = button.getAttribute('data-tab');

      // Aktualizovat hidden input hodnotu
      if (hiddenInput) {
        hiddenInput.value = customerType;
      }

      // Show/hide company field
      const isFirm = customerType === 'firm';
      if (companyField) {
        companyField.style.display = isFirm ? 'flex' : 'none';
      }

      if (companyInput) {
        if (isFirm) {
          companyInput.setAttribute('required', '');
        } else {
          companyInput.removeAttribute('required');
          companyInput.value = '';
          this.clearError(companyInput);
        }
      }
    };

    tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        // Remove active class from all buttons
        tabButtons.forEach((btn) => btn.classList.remove('active'));

        // Add active class to clicked button
        button.classList.add('active');

        // Update customer type
        updateCustomerType(button);

        // Animate red line based on button position
        const tabs = document.querySelector('.tabs');
        if (tabs) {
          tabs.setAttribute('data-active-tab', index);
        }
      });
    });

    // Nastavit počáteční hodnotu podle aktivního tlačítka při načtení
    const activeButton = document.querySelector('.tab-button.active');
    if (activeButton && hiddenInput) {
      updateCustomerType(activeButton);
    }
  }

  async handleSubmit(e) {
    e.preventDefault();

    if (this.isSubmitting) return;

    // Anti-spam: minimální čas 2 sekundy
    const timeSinceLoad = Date.now() - this.submissionStartTime;
    if (timeSinceLoad < 2000) {
      return;
    }

    // Honeypot check
    const honeypot = this.form.querySelector('.find-car-form__honeypot');
    if (honeypot && honeypot.value !== '') {
      return;
    }

    // Validace
    if (!this.validateForm()) {
      if (this.config.enableAnalytics) {
        this.trackEvent('form_error', { error_type: 'validation' });
      }
      return;
    }

    // Sesbírat data
    this.collectFormData();

    // Nastavit loading state
    this.setLoadingState(true);
    this.isSubmitting = true;

    try {
      // Odeslat na webhook
      const response = await this.sendToWebhook();

      if (response.ok) {
        // Úspěch
        this.showSuccess();

        // Analytics
        if (this.config.enableAnalytics) {
          this.trackEvent('form_submit');
          this.trackEvent('form_success');
        }
      } else {
        throw new Error(`HTTP ${response.status}`);
      }
    } catch (error) {
      this.showGlobalError(error.message);

      if (this.config.enableAnalytics) {
        this.trackEvent('form_error', { error_type: 'submission', error_message: error.message });
      }
    } finally {
      this.setLoadingState(false);
      this.isSubmitting = false;
    }
  }

  validateForm() {
    let isValid = true;
    const fields = this.form.querySelectorAll('input:not(.find-car-form__honeypot), textarea');

    fields.forEach((field) => {
      if (!this.validateField(field)) {
        isValid = false;
      }
    });

    return isValid;
  }

  validateField(field) {
    const value = field.value.trim();
    const isRequired = field.hasAttribute('required');
    const isVisible = field.offsetParent !== null;
    let errorMessage = '';

    // Skip pokud pole není viditelné
    if (!isVisible && !isRequired) {
      return true;
    }

    // Povinné pole
    if (isRequired && !value) {
      if (field.type === 'checkbox') {
        errorMessage = 'Toto pole je povinné';
      } else if (field.type === 'radio') {
        const checked = this.form.querySelector(`input[name="${field.name}"]:checked`);
        if (!checked) {
          errorMessage = 'Vyberte jednu z možností';
        }
      } else {
        errorMessage = 'Toto pole je povinné';
      }
    }

    // Email validace
    if (field.type === 'email' && value) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(value)) {
        errorMessage = 'Zadejte platný e-mail';
      }
    }

    // Telefon validace
    if (field.type === 'tel' && value) {
      const phoneRegex = /^[\d\s\+\-\(\)]{9,}$/;
      if (!phoneRegex.test(value)) {
        errorMessage = 'Zadejte platné telefonní číslo';
      }
    }

    // Roční nájezd validace - pouze čísla
    if (field.id === 'annualMileage' && value) {
      // Odstranit "km" a mezery pro validaci
      const numericValue = value.replace(/\s*km\s*$/i, '').trim();
      if (numericValue && !/^\d+$/.test(numericValue)) {
        errorMessage = 'Zadejte pouze číslo';
      }
    }

    // Zobrazit/skrýt error
    if (errorMessage) {
      this.showError(field, errorMessage);
      return false;
    } else {
      this.clearError(field);
      return true;
    }
  }

  showError(field, message) {
    if (!field) return;

    this.clearError(field);

    const errorDiv = document.createElement('div');
    errorDiv.className = 'form-error';
    errorDiv.textContent = message;
    errorDiv.setAttribute('data-error-for', field.id || field.name);

    field.insertAdjacentElement('afterend', errorDiv);
    field.classList.add('invalid');
  }

  clearError(field) {
    if (!field) return;

    const inputId = field.id || field.name;
    const errorElement = document.querySelector(`[data-error-for="${inputId}"]`);
    if (errorElement) {
      errorElement.remove();
    }
    field.classList.remove('invalid');
    field.style.borderColor = '';
  }

  collectFormData() {
    const formData = new FormData(this.form);

    const customerType = formData.get('customerType');
    const hiddenInput = this.form.querySelector('input[name="customerType"]');

    // Pokud FormData nemá hodnotu, použít hodnotu z hidden inputu
    const finalCustomerType = customerType || hiddenInput?.value || 'firm';

    const customerTypeMap = {
      private: 'Soukromá osoba',
      'self-employed': 'OSVČ',
      firm: 'Firma',
    };

    const customerTypeCzech = customerTypeMap[finalCustomerType] || finalCustomerType;

    this.formData = {
      customer: {
        type: customerTypeCzech,
        name: formData.get('fullName'),
        company: formData.get('companyName') || null,
        phone: this.normalizePhone(formData.get('phone')),
        email: formData.get('email'),
      },
      preferences: {
        brand: formData.get('preferredBrand') || null,
        model: formData.get('preferredModel') || null,
        annualMileage: this.normalizeMileage(formData.get('annualMileage')),
      },
      note: formData.get('note') || null,
      gdprConsent: formData.get('gdprConsent') === 'on',
      meta: this.collectMetadata(),
    };
  }

  normalizePhone(phone) {
    if (!phone) return '';

    // Odstranit mezery a speciální znaky
    let normalized = phone.replace(/[\s\-\(\)]/g, '');

    // Přidat +420 prefix automaticky (uživatel zadává jen 9 číslic)
    // Prefix +420 je zobrazen jako fixed label v UI
    normalized = '+420' + normalized;

    return normalized;
  }

  normalizeMileage(mileage) {
    if (!mileage) return null;

    // Odstranit "km", mezery a všechny ne-numerické znaky, nechat jen čísla
    const numericValue = mileage.replace(/\s*km\s*$/i, '').replace(/[^\d]/g, '');

    // Pokud po vyčištění zbylo nějaké číslo, vrátit ho jako string, jinak null
    return numericValue ? numericValue : null;
  }

  collectMetadata() {
    const urlParams = new URLSearchParams(window.location.search);

    return {
      url: window.location.href,
      locale: document.documentElement.lang || 'cs',
      themeId: window.Shopify?.theme?.id || null,
      themeName: window.Shopify?.theme?.name || null,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      referrer: document.referrer || null,
      utm: {
        source: urlParams.get('utm_source') || null,
        medium: urlParams.get('utm_medium') || null,
        campaign: urlParams.get('utm_campaign') || null,
        term: urlParams.get('utm_term') || null,
        content: urlParams.get('utm_content') || null,
      },
    };
  }

  async sendToWebhook() {
    const webhookUrl = this.config.webhookUrl;

    if (!webhookUrl) {
      throw new Error('Webhook URL not configured');
    }

    return fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.formData),
    });
  }

  setLoadingState(isLoading) {
    this.submitButton.disabled = isLoading;

    if (isLoading) {
      this.submitText.style.display = 'none';
      this.submitLoader.style.display = 'inline-block';
      this.form.style.pointerEvents = 'none';
      this.form.style.opacity = '0.6';
    } else {
      this.submitText.style.display = 'inline';
      this.submitLoader.style.display = 'none';
      this.form.style.pointerEvents = '';
      this.form.style.opacity = '';
    }
  }

  showSuccess() {
    this.form.style.display = 'none';
    this.successBox.style.display = 'block';

    try {
      window.sessionStorage.removeItem('driveto_car_finder_prefill');
      window.sessionStorage.removeItem('driveto_car_finder_prefill_applied');
    } catch {
      /* ignore */
    }

    // Hide customer type selector
    const askHowContainer = document.querySelector('.ask-how-container');
    if (askHowContainer) {
      askHowContainer.style.display = 'none';
    }

    // Hide heading and description
    const heading = document.querySelector('.find-car-form__heading');
    const description = document.querySelector('.find-car-form__description');
    if (heading) {
      heading.style.display = 'none';
    }
    if (description) {
      description.style.display = 'none';
    }

    // Change URL to include success parameter (like /cart?form=success)
    const url = new URL(window.location);
    url.searchParams.set('form', 'success');
    window.history.pushState({}, '', url);

    // Scroll to success
    this.successBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  showGlobalError(message) {
    // Zobrazit obecnou chybovou zprávu (pokud je potřeba)
    // Pro konzistenci s /cart můžeme použít alert nebo custom modal

    // Můžete přidat custom error box nebo alert
    if (this.config.errorMessage) {
      alert(this.config.errorMessage);
    }
  }

  trackEvent(eventName, eventData = {}) {
    if (!window.dataLayer) {
      return;
    }

    const eventPayload = {
      event: eventName,
      form_type: 'find_car',
      form_id: this.config.sectionId,
      ...eventData,
    };

    if (typeof window.__applyConsentThen === 'function') {
      window.__applyConsentThen(function () {
        if (typeof window.drivetoAnalyticsPush === 'function') {
          window.drivetoAnalyticsPush(eventPayload);
        }
      });
    } else if (typeof window.drivetoAnalyticsPush === 'function') {
      window.drivetoAnalyticsPush(eventPayload);
    }
  }
}

// Inicializace po načtení DOMu
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('findCarForm');
  if (form) {
    const formInstance = new FindCarForm(form);

    // Handle browser back/forward button
    window.addEventListener('popstate', () => {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('form') === 'success') {
        formInstance.showSuccess();
      } else {
        // Reload page to show form again
        window.location.reload();
      }
    });
  }
});
